import { Button } from "@mui/material";
import styled from "styled-components";

export const RenderRightHeader = styled.div`
  display: flex;
  padding: 16px;
  gap: 8px;
`;

export const SecondaryContainer = styled.div`
  display: flex;
  padding: 64px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  flex: 1 0 0;
  padding-top: 24px;
`;

export const LastUpdateText = styled.div`
  color: rgba(0, 0, 0, 0.38);
  text-align: center;
  font-size: 11px;
  font-style: italic;
  font-weight: 400;
  line-height: 14px;
  margin-top: 16px;
`;

const CarbonButton = styled(Button)`
  width: 200px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  text-transform: none;
  color: #FFF;
  background-color: var(--luft-primary);
  
  &:hover {
    background-color: var(--luft-primary-darker);
  }
`;

export const StyledButton = styled(CarbonButton)`
  && {
    background-color: var(--luft-primary);
    color: #fff;
    text-transform: none;
    display: flex;
    gap: 8px;

    &:hover {
      background-color: var(--luft-primary-darker);
    }
  }
`;

export const StyledButtonSecondary = styled(CarbonButton)`
  && {
    background-color: var(--luft-secondary);
    color: #fff;
    border: 1px solid #fff;
    text-transform: none;

    &:hover {
      background-color: var(--luft-primary);
    }
  }
`;

export const Wrapper = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Title = styled.div`
  color: var(--luft-primary);
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
`;

export const CarbonEmissionsHeader = styled.div`
  background-color: var(--luft-secondary);

  h1 {
    margin-left: 16px;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  flex-wrap: wrap;
`;

